'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var ch4o = require('ch4o');
var mitt = require('mitt');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var mitt__default = /*#__PURE__*/_interopDefaultLegacy(mitt);

function autoTypeCast(strKey, ...valueChunks) {
    let strValue = valueChunks.join('');
    try {
        strValue = decodeURIComponent(strValue).replace(/\+/g, ' ');
        strKey = decodeURIComponent(strKey);
    }
    catch (e) { }
    let value = strValue;
    let key = strKey;
    if (/^\d+$/.test(strValue)) {
        value = Number(strValue);
    }
    return { key, value };
}
function parseSearchParam(str) {
    let qs = str.replace(/#.*/, '');
    qs = qs.replace(/.*?\?/, '');
    return qs.split(/&+/).reduce((res, entryString) => {
        let { key, value } = autoTypeCast.apply(null, entryString.split('='));
        res[key] = value;
        return res;
    }, {});
}
/**
 * 获取url上的query参数
 * @param {string} str
 * @returns 一个键值对的对象
 */
function queryToJson(str) {
    try {
        str = window.location.href;
    }
    catch (error) { }
    return parseSearchParam(str);
}
/**
 * 深拷贝，如果只有一个参数，则默认第一个为数据源
 * 它将两个对象合并在一起。
 * @param {object} target - 要合并到的目标对象。
 * @param {object} [source] - 要合并到目标对象的源对象。
 */
function deepMerge(target, source) {
    if (arguments.length === 1) {
        source = arguments[0];
        target = Array.isArray(source) ? [] : {};
    }
    if (!target) {
        throw Error('Cannot convert undefined or null to object');
    }
    throw new TypeError(`This function not been implemented!`);
}
/**
 * 它返回传递给它的对象的深层副本。
 * @param {object} obj - 要克隆的对象。
 * @returns 一个新对象，它是原始对象的克隆。
 */
function deepCopy(obj) {
    if (arguments.length > 1) {
        console.warn(`This function 不再接受第二个参数, 并且，现在返回 一个新的克隆对象`);
    }
    return ch4o.clone(obj);
}
function R(i) {
    const t = +new Date;
    const r = Math.random();
    let bn = (t * (r + i)).toString(16).replace(/^[a-f0-9]{4}/, '$&-').replace('.', '-');
    return bn;
}
function* GUID(c = 0) {
    let n = 0;
    while (c++) {
        yield R(c + n++);
    }
}

// @ts-ignore
/**
 * 内置频道
 */
const channels = {
    'default': mitt__default["default"](),
    'toast': mitt__default["default"](),
    'log': mitt__default["default"](),
};
/**
 * 找到channel的实例
 * @param ch
 */
function getChannel(ch = 'default') {
    const channel = channels[ch];
    if (!channel) {
        console.error(`No channel named '${ch}'`);
        return null;
    }
    return channel;
}
/**
 * 监听全局消息
 * @param eventName
 * @param callback
 * @param ch
 */
function listenEvent(eventName, callback, ch) {
    getChannel(ch)?.on(eventName, callback);
}
/**
 * 向消息中心发送消息
 * @param {string} eventName
 * @param {Record<string, unknown>} data
 * @param {chName=} ch 频道名称
 */
function dispatchEvent(eventName, data, ch) {
    getChannel(ch)?.emit(eventName, data);
}

/**
 * 获取指定字符串的主域名，不传则为当前域名
 * @param str 获取指定字符串的主域名，不传则为当前域名
 * @returns 解析失败则返回空
 */
function getDomainV2(str) {
    str = str || window.location.hostname;
    let arr = str.match(/([a-zA-Z\d][a-zA-Z\d\-]*?\.(?:[a-zA-Z\d]+)(?:\.(?:[a-zA-Z\d]))*)([\/|\?].*)?$/i) || [];
    return arr.length > 1 ? arr[1] : '';
}

exports.GUID = GUID;
exports.deepCopy = deepCopy;
exports.deepMerge = deepMerge;
exports.dispatchEvent = dispatchEvent;
exports.getDomainV2 = getDomainV2;
exports.listenEvent = listenEvent;
exports.parseSearchParam = parseSearchParam;
exports.queryToJson = queryToJson;
